var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPriceArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "11px",
    viewBox: "0 0 18 11",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "7E685FBF-FF2E-41CC-984A-E3BC6ECF90C2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Car-insurance---14---Compact-views",
    transform: "translate(-976.000000, -1131.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-35-Copy-2",
    transform: "translate(51.000000, 868.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-29-Copy-8",
    transform: "translate(674.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-28"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Component-23-\\u2013-1",
    transform: "translate(10.000000, 244.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-26",
    transform: "translate(155.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-25",
    transform: "translate(15.000000, 13.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path-Copy-34",
    transform: "translate(79.802045, 11.250000) scale(-1, -1) translate(-79.802045, -11.250000) ",
    points: "77.3624187 7.11245353 73.9860595 10.4888127 88.6040892 10.4888127 88.6040892 12.0501859 74.0250929 12.0501859 77.3625232 15.3874768 76.25 16.5 71 11.25 76.25 6"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceArrow);
export default __webpack_public_path__ + "static/media/price-arrow.3e35776b0b30f43e6595b90d21ab430b.svg";
export { ForwardRef as ReactComponent };